export class ConsumptionFilters {
  alias: string;
  organizationUuids: string[];
  localities: string[];
  countries: string[];
  states: string[];
  machineUuids: string;
  machineModelUuids: string[];
  from: number;
  until: number;
}
